export const APP_TOUR_TUTORIAL_ID = 'appTour';
export const ONBOARDING_TUTORIAL_ID = 'tutorialModal';
export const APP_TOUR_MIN_VERSION = 1;

export type OnboardingTutorialFlags = {
  tutorialModal?: boolean;
  firstTutorial?: boolean;
  completed_tutorials?: Record<string, number | string | undefined>;
} | null | undefined;

export type PendingOnboardingStep = 'onboarding' | 'appTour' | null;

const completedVersion = (
  tutorials: NonNullable<OnboardingTutorialFlags>,
  id: string
): number => {
  const parsed = Number(tutorials.completed_tutorials?.[id]);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function isOnboardingDone(tutorials: OnboardingTutorialFlags): boolean {
  if (!tutorials) return true;
  return (
    tutorials.tutorialModal === true ||
    tutorials.firstTutorial === true ||
    completedVersion(tutorials, ONBOARDING_TUTORIAL_ID) >= 1 ||
    completedVersion(tutorials, APP_TOUR_TUTORIAL_ID) >= 1
  );
}

export function isAppTourDone(tutorials: OnboardingTutorialFlags): boolean {
  if (!tutorials) return true;
  return (
    tutorials.firstTutorial === true ||
    completedVersion(tutorials, APP_TOUR_TUTORIAL_ID) >= APP_TOUR_MIN_VERSION
  );
}

/**
 * Which first-run step a user still owes, derived only from persisted `userData.tutorials`
 * (Redux `UI` is not persisted, so a force close drops `onboardingInProgress`).
 * Unknown tutorials resolve to `null` so a missing profile never forces a flow.
 */
export function resolvePendingOnboardingStep(
  tutorials: OnboardingTutorialFlags
): PendingOnboardingStep {
  if (!tutorials) return null;
  if (!isOnboardingDone(tutorials)) return 'onboarding';
  if (!isAppTourDone(tutorials)) return 'appTour';
  return null;
}
